/**
 * Shop by Sound — product grid filter
 */
(function () {
  'use strict';

  function bindProductFilter() {
    document.querySelectorAll('[data-sbs-shop]').forEach((shop) => {
      if (shop.dataset.sbsBound === '1') return;
      shop.dataset.sbsBound = '1';

      const tabs = shop.querySelectorAll('[data-sbs-tab]');
      const chipGroups = shop.querySelectorAll('[data-sbs-chips]');
      const products = shop.querySelectorAll('[data-sbs-product]');
      const moreCards = shop.querySelectorAll('[data-sbs-more]');
      const empty = shop.querySelector('[data-sbs-empty]');
      const mobileMq = window.matchMedia('(max-width: 749px)');

      let mode = 'sound';
      let chip = '';

      const useCatPanels = Array.from(products).some((el) => {
        const m = el.getAttribute('data-mode');
        return m && m !== 'all';
      });

      const getLimit = () => (mobileMq.matches ? 5 : 7);

      const matchesPanel = (el) => {
        const elMode = el.getAttribute('data-mode') || '';
        const elChip = (el.getAttribute('data-chip') || '').toLowerCase();
        return elMode === mode && (!chip || elChip === chip.toLowerCase());
      };

      const apply = () => {
        const limit = getLimit();
        let visible = 0;
        let matched = 0;

        if (useCatPanels) {
          products.forEach((el) => {
            const match = matchesPanel(el);
            if (!match) {
              el.classList.add('is-hidden');
              return;
            }
            matched += 1;
            const show = matched <= limit;
            el.classList.toggle('is-hidden', !show);
            if (show) visible += 1;
          });
          moreCards.forEach((el) => {
            const count = parseInt(el.getAttribute('data-count') || '0', 10);
            const show = matchesPanel(el) && count > limit;
            el.classList.toggle('is-hidden', !show);
          });
        } else {
          let anyTagged = false;
          products.forEach((el) => {
            const values = (el.getAttribute(`data-${mode}`) || '').toLowerCase().split(/\s+/).filter(Boolean);
            if (values.length) anyTagged = true;
          });

          products.forEach((el) => {
            const values = (el.getAttribute(`data-${mode}`) || '').toLowerCase().split(/\s+/).filter(Boolean);
            const match =
              !chip ||
              !anyTagged ||
              values.length === 0 ||
              values.some((v) => v.includes(chip.toLowerCase()));
            if (!match) {
              el.classList.add('is-hidden');
              return;
            }
            matched += 1;
            const show = matched <= limit;
            el.classList.toggle('is-hidden', !show);
            if (show) visible += 1;
          });
          moreCards.forEach((el) => {
            const elMode = el.getAttribute('data-mode') || '';
            const count = parseInt(el.getAttribute('data-count') || '0', 10);
            const panelOk = elMode === 'all' || elMode === mode;
            el.classList.toggle('is-hidden', !(panelOk && count > limit));
          });
        }

        if (empty) empty.hidden = visible > 0;
      };

      const activateFirstChip = (group) => {
        group.querySelectorAll('[data-sbs-chip]').forEach((c) => c.classList.remove('is-active'));
        const first = group.querySelector('[data-sbs-chip]');
        if (first) {
          first.classList.add('is-active');
          chip = first.getAttribute('data-sbs-chip') || '';
        } else {
          chip = '';
        }
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          mode = tab.getAttribute('data-sbs-tab') || 'sound';
          tabs.forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', String(active));
          });

          chipGroups.forEach((group) => {
            const active = group.getAttribute('data-sbs-chips') === mode;
            group.hidden = !active;
            if (active) activateFirstChip(group);
          });
          apply();
        });
      });

      chipGroups.forEach((group) => {
        group.querySelectorAll('[data-sbs-chip]').forEach((chipBtn) => {
          chipBtn.addEventListener('click', (event) => {
            const catUrl = chipBtn.getAttribute('data-sbs-cat-url');
            if (catUrl && (event.metaKey || event.ctrlKey)) {
              window.location.href = catUrl;
              return;
            }

            group.querySelectorAll('[data-sbs-chip]').forEach((c) => c.classList.remove('is-active'));
            chipBtn.classList.add('is-active');
            chip = chipBtn.getAttribute('data-sbs-chip') || '';
            apply();
          });
        });
      });

      if (typeof mobileMq.addEventListener === 'function') {
        mobileMq.addEventListener('change', apply);
      } else if (typeof mobileMq.addListener === 'function') {
        mobileMq.addListener(apply);
      }

      const soundChips = shop.querySelector('[data-sbs-chips="sound"]');
      if (soundChips) activateFirstChip(soundChips);
      apply();
    });
  }

  function boot() {
    bindProductFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
